"use client"; // Error components must be Client Components

import { useEffect } from "react";

export default function Error({ error }: { error: Error; reset: () => void }) {
  useEffect(() => {
    // H.consumeError(error);
    console.error(error);
  }, [error]);

  return (
    <div className="text-primary-background pt-16 text-center">
      <h2 className="mb-2 text-4xl font-medium">
        Something went wrong on our side :(
      </h2>
      <p className="text-lg">
        Please try refreshing the page or visit us again later when we resolved
        the issue!
      </p>
    </div>
  );
}
